import PurchaseSuccess from './PurchaseSuccess';

export default PurchaseSuccess;
